export default __webpack_public_path__ + "static/media/time-farmer.c6df061f.jpeg";